var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultProfilePicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_678",
    "data-name": "Ellipse 678",
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    transform: "translate(0.271 0.271)",
    fill: "#6b1582"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12729",
    "data-name": "Group 12729",
    transform: "translate(-0.271 -0.271)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_679",
    "data-name": "Ellipse 679",
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    transform: "translate(0.271 0.271)",
    fill: "#bed752"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12747",
    "data-name": "Group 12747",
    transform: "translate(7.491 6.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12734",
    "data-name": "Group 12734",
    transform: "translate(0 47.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    d: "M0,0H54.6a0,0,0,0,1,0,0V.143A23.194,23.194,0,0,1,31.407,23.337H23.337A23.337,23.337,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(54.601 23.337) rotate(180)",
    fill: "#2b4047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12745",
    "data-name": "Group 12745",
    transform: "translate(11.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12744",
    "data-name": "Group 12744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12735",
    "data-name": "Group 12735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23903",
    "data-name": "Path 23903",
    d: "M245.327,27.309c-4.322-2.683-6.188-6.828-12.459-5.819a7.18,7.18,0,0,0-4.947,3.138,4.969,4.969,0,0,0-.82,2.291L223.989,27a6.3,6.3,0,0,0-5.808,8.283l2.281,3.989-.093,9.289A5.08,5.08,0,0,0,225.4,53.7l15.884.159a5.08,5.08,0,0,0,5.131-5.029l.1-9.563C248.581,37.213,251.412,31.086,245.327,27.309Z",
    transform: "translate(-217.856 -21.335)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23904",
    "data-name": "Path 23904",
    d: "M245.208,53.236l-1.006-.01.045-4.456a3.981,3.981,0,0,0-.492-.625,6.226,6.226,0,0,0-5.012-1.685c-12.006,1.294-13.654-3.482-13.654-3.482-3.334,1.731-2.626,10.612-2.626,10.612l-.334-.585L221.243,53a3.288,3.288,0,0,0-3.321,3.254l-.007.731a3.288,3.288,0,0,0,3.255,3.32l.927.009-.045,4.485a8.38,8.38,0,0,0,4.222,7.36V81.3H240.1V72.029a8.371,8.371,0,0,0,3.929-7.013V65a7.088,7.088,0,0,0,.058-.808l.037-3.663,1.006.01a3.288,3.288,0,0,0,3.321-3.255l.007-.73A3.288,3.288,0,0,0,245.208,53.236Z",
    transform: "translate(-217.886 -32.202)",
    fill: "#ffba94"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_23905",
    "data-name": "Path 23905",
    d: "M248.548,94.069a5.195,5.195,0,1,1-5.142-5.246A5.195,5.195,0,0,1,248.548,94.069Z",
    transform: "translate(-228.05 -55.22)",
    fill: "#ff8571",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23906",
    "data-name": "Path 23906",
    d: "M232.889,81.644l8.588.086a6.7,6.7,0,0,0,6.764-6.63l.257-13.448-3.124,6.51L229.5,68.029l-3.168-7.36L226.26,74.88A6.7,6.7,0,0,0,232.889,81.644Z",
    transform: "translate(-222.075 -41.084)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12743",
    "data-name": "Group 12743",
    transform: "translate(2.092 17.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23907",
    "data-name": "Path 23907",
    d: "M222.64,69.689a.249.249,0,0,1-.163-.437l.7-.6-1.057-1.234a.249.249,0,0,1,.378-.324l1.38,1.611-1.072.925A.25.25,0,0,1,222.64,69.689Z",
    transform: "translate(-222.057 -61.411)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23908",
    "data-name": "Path 23908",
    d: "M274.481,71.056a.248.248,0,0,1-.166-.064l-1.054-.947,1.413-1.583a.249.249,0,1,1,.371.332l-1.082,1.213.685.615a.249.249,0,0,1-.166.434Z",
    transform: "translate(-247.766 -62.1)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12740",
    "data-name": "Group 12740",
    transform: "translate(6.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12739",
    "data-name": "Group 12739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12738",
    "data-name": "Group 12738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12736",
    "data-name": "Group 12736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23909",
    "data-name": "Path 23909",
    d: "M235.476,57.959a2.526,2.526,0,0,0,1.058-.112c.368-.09.739-.171,1.065-.23s.7-.114,1.078-.159a2.5,2.5,0,0,0,1.029-.266c.258-.171.312-.536-.094-.9a2.9,2.9,0,0,0-2.355-.464,2.845,2.845,0,0,0-2.026,1.258C234.987,57.568,235.171,57.89,235.476,57.959Z",
    transform: "translate(-235.118 -55.768)",
    fill: "#703127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12737",
    "data-name": "Group 12737",
    transform: "translate(10.065 0.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23910",
    "data-name": "Path 23910",
    d: "M259.873,58.376a2.521,2.521,0,0,1-1.063.023c-.376-.042-.755-.076-1.085-.093s-.711-.024-1.089-.021a2.5,2.5,0,0,1-1.053-.134c-.277-.136-.375-.492-.017-.9a2.9,2.9,0,0,1,2.28-.759,2.826,2.826,0,0,1,2.164.991C260.309,57.926,260.167,58.269,259.873,58.376Z",
    transform: "translate(-255.334 -56.483)",
    fill: "#703127"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23911",
    "data-name": "Path 23911",
    d: "M240.845,66.84a.823.823,0,1,1-1.091-.4A.822.822,0,0,1,240.845,66.84Z",
    transform: "translate(-230.702 -61.087)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23912",
    "data-name": "Path 23912",
    d: "M240.649,69.8a.248.248,0,0,1-.115-.028,1.546,1.546,0,0,0-1.52-.03.249.249,0,0,1-.273-.416,2.039,2.039,0,0,1,2.023,0,.249.249,0,0,1-.115.47Z",
    transform: "translate(-230.378 -62.446)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23913",
    "data-name": "Path 23913",
    d: "M258.839,67.02a.823.823,0,1,1-1.092-.4A.823.823,0,0,1,258.839,67.02Z",
    transform: "translate(-239.737 -61.178)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23914",
    "data-name": "Path 23914",
    d: "M258.644,69.985a.247.247,0,0,1-.116-.028,1.545,1.545,0,0,0-1.519-.03.249.249,0,0,1-.274-.416,2.037,2.037,0,0,1,2.023,0,.249.249,0,0,1-.115.47Z",
    transform: "translate(-239.413 -62.537)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23915",
    "data-name": "Path 23915",
    d: "M233.546,72.012c.032.623,1.06,1.077,2.3,1.014s2.213-.619,2.181-1.242-1.06-1.076-2.3-1.014S233.514,71.39,233.546,72.012Z",
    transform: "translate(-227.825 -63.298)",
    fill: "#ff8e77",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23916",
    "data-name": "Path 23916",
    d: "M255.7,72.012c.032.623,1.06,1.077,2.3,1.014s2.213-.619,2.181-1.242-1.06-1.076-2.3-1.014S255.668,71.39,255.7,72.012Z",
    transform: "translate(-238.948 -63.298)",
    fill: "#ff8e77",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23917",
    "data-name": "Path 23917",
    d: "M247.6,69.3c-.225,0-.46-.01-.7-.029a.249.249,0,0,1,.04-.5,7.279,7.279,0,0,0,1.214,0,1.827,1.827,0,0,0,1.47-.771.7.7,0,0,0,.008-.689l-1.9-3.608a.249.249,0,1,1,.441-.232l1.9,3.608a1.193,1.193,0,0,1-.011,1.159,2.316,2.316,0,0,1-1.864,1.029C248,69.29,247.805,69.3,247.6,69.3Z",
    transform: "translate(-234.413 -59.572)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12742",
    "data-name": "Group 12742",
    transform: "translate(8.898 11.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12741",
    "data-name": "Group 12741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23918",
    "data-name": "Path 23918",
    d: "M240.882,78.132a15.616,15.616,0,0,0,4.242.777c2.094.03.951,3.707-2.218,3.834S239.157,77.993,240.882,78.132Z",
    transform: "translate(-239.928 -78.129)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12746",
    "data-name": "Group 12746",
    transform: "translate(16.114 41.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23919",
    "data-name": "Path 23919",
    d: "M227.32,105.212l-.786,5.071,3.806,6.739a1.056,1.056,0,0,0,1.7.191l5.476-5.132-8.327-7.476A1.1,1.1,0,0,0,227.32,105.212Z",
    transform: "translate(-226.534 -104.278)",
    fill: "#f8f8ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23920",
    "data-name": "Path 23920",
    d: "M256.109,105.255l-8.255,7.253,4.186,5.51a1.084,1.084,0,0,0,1.652-.03l5.316-6.5-2.06-6.006A.525.525,0,0,0,256.109,105.255Z",
    transform: "translate(-237.239 -104.705)",
    fill: "#f8f8ee"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfilePicture);
export default __webpack_public_path__ + "static/media/default-profile-picture.419aa69c02ef5c0df64ed3c1e3629e1c.svg";
export { ForwardRef as ReactComponent };